import { render, staticRenderFns } from "./ModalReviewJustification.vue?vue&type=template&id=2a2ef100"
import script from "./ModalReviewJustification.vue?vue&type=script&lang=js"
export * from "./ModalReviewJustification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports